import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faPhone } from '@fortawesome/pro-solid-svg-icons';
import {entryNumberSet} from "../component/options";

const abiFilersContact = [
  {
    name: 'contactName',
    label: 'Contact Name',
    type: 'text',
    maxLength: 40,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: <FontAwesomeIcon icon={faUser} />,
  },
  {
    name: 'contactPhone',
    label: 'Contact Phone',
    type: 'text',
    maxLength: 15,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: <FontAwesomeIcon icon={faPhone} />,
  },
  {
    type: 'new',
  },
  {
    name: 'declarantName',
    label: 'Declarant Name',
    type: 'text',
    maxLength: 40,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
  },
  {
    name: 'declarantTitle',
    label: 'Declarant Title',
    type: 'text',
    maxLength: 30,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
  },
  {
    type: 'new',
  },
  {
    name: 'declarantSignature',
    label: 'Declarant Signature',
    type: 'file',
    placeholder: '',
    required: false,
    disabled: false,
    // the following props are all optional. See defaults in `src\components\era-package\forms\FileUploadModal.jsx`
    fileUploadProps: {
      acceptedFileTypes: ['.jpg','.png','.jpeg'],
      maxFileSize: 16 * 1024 * 1024, // 5 MB
      title: 'Upload Declarant Signature',
      description: 'Upload Declarant Signature',
    }
  },
  {
    name: 'declarantSignatureFilename',
    label: 'Current Uploaded Declarant Signature',
    type: 'text',
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: true,
  },
  {
    type: 'new',
  },
  {
    name: 'brokerName',
    label: 'Broker Name',
    type: 'text',
    maxLength: 40,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
  },
  {
    name: 'brokerPhone',
    label: 'Broker Phone',
    type: 'text',
    maxLength: 15,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
  },
  {
    type: 'new',
  },
  {
    name: 'brokerAddress',
    label: 'Broker Address',
    type: 'text',
    maxLength: 200,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
  },
  {
    name: 'payersUnitNumber',
    label: 'Payer\'s Unit Number',
    type: 'text',
    maxLength: 15,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
  },
];

const esHeaderAbiFilersContact = [
  {
    name: 'contactName',
    label: 'Contact Name',
    type: 'text',
    maxLength: 40,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: <FontAwesomeIcon icon={faUser} />,
  },
  {
    name: 'contactPhone',
    label: 'Contact Phone',
    type: 'text',
    maxLength: 15,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: <FontAwesomeIcon icon={faPhone} />,
  },
];

const abiFiler1 = [
  {
    name: 'filerPortCode',
    label: 'Port Code',
    type: 'text',
    maxLength: 4,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'filerOfficeCode',
    label: 'Office Code',
    type: 'text',
    maxLength: 2,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'filerCode',
    label: 'Filer Code',
    type: 'text',
    maxLength: 3,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined,
  },
];

const abiFiler2 = [
  {
    name: 'entryNumberSet',
    label: 'Set',
    type: 'auto value',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'entryNumberRangeStart',
    label: 'Range Start',
    type: 'number',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'entryNumberRangeEnd',
    label: 'Range End',
    type: 'number',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: true,
    disabled: false,
    icon: undefined,
  },
  {
    name: 'currentEntryNumber',
    label: 'Current',
    type: 'number',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: true,
    icon: undefined,
  },
];

const optionsMap = {
  entryNumberSet: entryNumberSet,
};

export { abiFilersContact, esHeaderAbiFilersContact, abiFiler1, abiFiler2, optionsMap };